// Pure helpers for the Funding Confirmation inbox (Josh 10/23). Folder membership is
// decided by the API (services.funding_confirmations.folder_of); this only labels,
// filters by the search box and formats rows. No React, no axios — Jest-tested.

export const FOLDER_LABELS = {
  drafts: 'Drafts',
  awaiting: 'Awaiting merchant',
  review: 'Needs review',
  completed: 'Completed',
  corrections: 'Corrections requested',
  closed: 'Closed / expired',
};

export const FOLDER_HINTS = {
  drafts: 'Link generated, no code sent yet. Send the link to the merchant or revoke it.',
  awaiting: 'The merchant has requested a code or verified; waiting for the signed acknowledgment.',
  review: 'Completed, but a disclosure answer needs staff review before funding.',
  completed: 'Signed acknowledgments with evidence on file.',
  corrections: 'The merchant said something is wrong. Fix the deal, then issue a fresh link.',
  closed: 'Revoked or expired links. Issue a new link to try again.',
};

export const STATUS_LABELS = {
  pending: 'Link issued',
  verified: 'Contact verified',
  completed: 'Completed',
  correction_requested: 'Correction requested',
  revoked: 'Revoked',
};

// Josh 10/27: a completed confirmation shows "as completed with a green bubble" — same bubble on the
// deal's Confirmation tab and in the inbox.
export const STATUS_BUBBLE = {
  pending: 'bg-slate-100 text-slate-700',
  verified: 'bg-blue-100 text-blue-800',
  completed: 'bg-emerald-100 text-emerald-800',
  correction_requested: 'bg-amber-100 text-amber-900',
  revoked: 'bg-red-100 text-red-800',
};

export const statusBubbleClass = (status) =>
  `inline-block rounded-full px-2.5 py-0.5 text-xs font-semibold ${STATUS_BUBBLE[status] || 'bg-slate-100 text-slate-700'}`;

export const statusLabel = (status) => STATUS_LABELS[status] || String(status || '').replaceAll('_', ' ');

const norm = (v) => String(v || '').toLowerCase();

/** Rows whose business, deal number, signer, company or id contain the query. */
export function filterRows(rows, query) {
  const q = norm(query).trim();
  if (!q) return rows || [];
  return (rows || []).filter((r) => [r.business_name, r.deal_number, r.signer_name, r.company, r.id]
    .some((v) => norm(v).includes(q)));
}

/** Josh 10/28: a completed row opens its disclosure answers in place (review happens there);
 *  any other row still goes to the deal's Confirmation tab. */
export function rowOpensInPlace(row) {
  return row?.status === 'completed';
}

export const REVIEW_LABELS = { cleared: 'Cleared for funding', declined: 'Declined after review' };

export const reviewLabel = (review) => (review?.decision ? REVIEW_LABELS[review.decision] || review.decision : '');

/** Deal-page URL that opens the Confirmation tab for this row. */
export function dealTabUrl(row) {
  return row?.deal_id ? `/deals/${row.deal_id}?tab=confirmation` : null;
}

/** Normalise the deals search response (array, or {deals: [...]}) to picker options. */
export function dealOptions(data) {
  const list = Array.isArray(data) ? data : (data?.deals || []);
  return list.map((d) => ({ id: d.id, deal_id: d.deal_id, name: d.deal_name || d.company_name || '', status: d.status || '' }))
    .filter((d) => d.id);
}
